import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=bd2f0a62&scoped=true&lang=pug&"
import script from "./menus.vue?vue&type=script&lang=coffee&"
export * from "./menus.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2f0a62",
  null
  
)

export default component.exports